import { useLastOrdersStore } from '~/store/lastOrders';

export const useLastOrders = () => {
  const lastOrdersStore = useLastOrdersStore();

  const startCheckLastOrders = async () => {
    if (process.client) {
      try {
        await lastOrdersStore.startCheckLastOrders();
      } catch (error) {
        console.error('Error starting check last orders:', error);
      }
    }
  };

  return {
    startCheckLastOrders
  };
};

